
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/obituaries/[slug]",
      function () {
        return require("private-next-pages/obituaries/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/obituaries/[slug]"])
      });
    }
  